var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.075 68.25L54.075 102.25C51.725 104.6 47.925 104.6 45.6 102.25L39.95 96.6C37.6 94.25 37.6 90.45 39.95 88.125L64.05 64.0251L39.95 39.925C37.6 37.575 37.6 33.775 39.95 31.45L45.575 25.75C47.925 23.4 51.725 23.4 54.05 25.75L88.05 59.75C90.425 62.1 90.425 65.9 88.075 68.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRight);
export default __webpack_public_path__ + "static/media/angle-right.e24170a058481f9c65861cfe2a8f783c.svg";
export { ForwardRef as ReactComponent };